import axios from 'axios'
import { Message } from 'view-design'
import store from '@/store'
import router from '@/router'
import { TOKEN_STORAGE } from '@/config'

// baseURL 取当前线路(运行时可切换,对齐原站线路切换)
const service = axios.create({ timeout: 15000 })

service.interceptors.request.use(
  (config) => {
    // 当前线路 baseURL(store.getters.currentApiBase = 线路域名 + /api/v1/admin)
    config.baseURL = store.getters.currentApiBase

    // 鉴权:lottery-go admin 走 JWT Bearer(登录换 token,Redis 单会话)
    const token = store.state.user.token || localStorage.getItem(TOKEN_STORAGE) || ''
    if (token) config.headers['Authorization'] = 'Bearer ' + token

    // 敏感操作(调余额/审批/改密)需先 POST /auth/secure-password/verify 拿一次性 token,
    // 页面对接时把它塞进 config.headers['X-Secure-Token']。
    // 注:admin 端明文 JSON,不做整体 AES;也不校验 sign/timestamp(已移除)。
    return config
  },
  (err) => Promise.reject(err)
)

service.interceptors.response.use(
  (resp) => {
    const res = resp.data
    // lottery-go 统一包 {code,data,msg,serverTime},HTTP 恒 200,业务码在 body
    if (res && res.code !== undefined && res.code !== 0) {
      if (res.code === 401) {
        Message.error('登录已失效')
        router.replace('/login')
        return Promise.reject(res)
      }
      // 对接进行中:业务错误静默(避免未接页面刷屏),交页面自行处理
      console.warn('[api]', res.code, res.msg)
      return Promise.reject(res)
    }
    return res && res.data !== undefined ? res.data : res
  },
  (err) => {
    // 对接进行中:未接的接口会 404,静默不刷屏
    console.warn('[api] 请求失败(对接中,未接接口会 404)', err.message)
    return Promise.reject(err)
  }
)

export default service
